import { axios } from "../../util/axiosConfig";
import { account } from "../urls";

const getUserDetails = () =>
  axios.get(account.fullDetails).then(response => response.data);

export default getUserDetails;
